// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.3295fc98.css";
	// return url for filenames based on template
	return "" + chunkId + "." + "bc6f0842" + ".chunk.css";
};